import React, { Component } from "react";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import { GridContainer, Loader } from "arv-reactcomponents";
import { FULL_WIDTH_MASTER_TEMPLATES } from "../../constants";
import MasterComponent from "../../component/MasterTemplate/MasterComponent";
import { setPageType } from "../../utils";
import Analytics from "../../analytics";

@inject("BrandStore")
@observer
class BrandPage extends Component {
  static getTemplateClass(props) {
    const { templateType } = props.BrandStore;
    const type = FULL_WIDTH_MASTER_TEMPLATES.includes(templateType)
      ? "nw-fullwidthtemplate"
      : "nw-mastertemplatelayout";
    return `nw-${templateType.toLowerCase()} ${type}`;
  }
  constructor(props) {
    super(props);
    this.state = {
      templateClass: BrandPage.getTemplateClass(props),
    };
  }
  componentDidMount() {
    const { data, templateType } = this.props.BrandStore;
    setPageType(templateType);
    Analytics.pageView(window.pageType);
    if (!data) {
      this.props.BrandStore.getBrandPageData();
    }
  }
  get validatedSections() {
    const { data } = toJS(this.props.BrandStore);
    return (data && data.filter(item => item.type)) || [];
  }
  render() {
    const { data } = toJS(this.props.BrandStore);
    const { templateClass } = this.state;
    if (!data)
      return (
        <div>
          <div className="nw-mastertemplatepage-loading">
            <Loader />
          </div>
        </div>
      );
    return (
      <GridContainer className={`nw-mastertemplatepage ${templateClass}`}>
        {this.validatedSections.map((component, index) => (
          <MasterComponent
            data={component}
            key={component.type}
            sectionIndex={index}
          />
        ))}
      </GridContainer>
    );
  }
}

BrandPage.wrappedComponent.propTypes = {
  BrandStore: PropTypes.shape({
    templateType: PropTypes.string.isRequired,
    getBrandPageData: PropTypes.func.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};
export default BrandPage;



// WEBPACK FOOTER //
// ./src/pages/BrandPage/index.js